import styled from 'styled-components';

export const VActivityTabsContainer = styled.div`
    width: 100%;
    margin: 20px 0;

    @media (min-width: 992px) {
        margin: 30px 0;
    }
`;
